/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Onboarding_TitleInputs */

const en_meta_onboarding_title = /** @type {(inputs: Meta_Onboarding_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up Listening — your personal reader`)
};

const es_meta_onboarding_title = /** @type {(inputs: Meta_Onboarding_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura Listening: tu lector personal`)
};

/**
* | output |
* | --- |
* | "Set up Listening — your personal reader" |
*
* @param {Meta_Onboarding_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_onboarding_title = /** @type {((inputs?: Meta_Onboarding_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Onboarding_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_onboarding_title(inputs)
	return en_meta_onboarding_title(inputs)
});